import { memo } from "react";
import Skills from "./Skills";
import { theme } from "../../../../theme";

const SelectSkills = ({ skill, setSkill, subSkill, setSubSkill, isHome=false, handleReset=null }) => {
    if(isHome){
        return(
            <Skills
                selectSkill={skill}
                setSkill={setSkill}
                selectSubSkill={subSkill}
                setSubSkill={setSubSkill}
                isHome={isHome}
                handleReset={handleReset}
            />
        );
    }

    return (
        <div className="card h-100 border border-dark">
            <span className={`badge rounded-pill bg-${theme.main} text-light text-bolder w-50 mt-n3 mx-auto`}>
                Select Skill
            </span>

            <div className="card-header text-center pt-4 pb-3">
                <h3 className="font-weight-bold mt-2">{subSkill?.sub_skill_name || "N/A"}</h3>
            </div>

            <div className="card-body text-lg-start text-center pt-0">
                <Skills
                    selectSkill={skill}
                    setSkill={setSkill}
                    selectSubSkill={subSkill}
                    setSubSkill={setSubSkill}
                />
            </div>
        </div>
    );
};

export default memo(SelectSkills);
